import styled from 'styled-components';
export const Container = styled.div`
    display: flex;
    height: 2rem;
    align-items: center;
    gap: .5rem;
    
    input{
        width: 1.5rem;
        height: 1.5rem;
        cursor: pointer;
    }

    span{
        cursor: default;
        color:${({theme})=>theme.colors.__white};
        font-weight: bold;
    }

`;
